(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/pickers/race-picker.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/pickers/race-picker.js');

'use strict';

const {
  RacePickerItem
} = svs.racing;
const {
  useState,
  useEffect,
  useRef,
  useMemo
} = React;
const {
  Link
} = ReactRouterDOM;
const {
  buildLocationFromRace
} = svs.racing.navigation.location;
const {
  subProductIdToGameType
} = svs.racing.common.constants;
const {
  navigation
} = svs.racing;
const Icon = svs.ui.ReactIcon;
const useRaceJackpots = svs.racing.raceService.useRaceJackpots;
const RacePicker = _ref => {
  let {
    raceSummaries
  } = _ref;
  const getFirstJackpot = useRaceJackpots().getFirstJackpot;
  const navState = navigation.useNavigationState();
  const lastSummary = raceSummaries[raceSummaries.length - 1];
  const firstSummary = raceSummaries[0];
  const arrowButtonWidth = 40;

  let scrollIndex;
  const racePickerRef = useRef(null);
  const rightArrowRef = useRef(null);
  const lastItemRef = useRef({});
  const selectedId = useMemo(() => {
    if (raceSummaries) {
      const result = raceSummaries.find(raceSummary => raceSummary.meeting.formattedDate === navState.day && raceSummary.meeting.track.urlName === navState.trackName && raceSummary.raceNumber.toString() === navState.raceNumber);
      return result ? result.raceId : undefined;
    }
    return undefined;
  }, [navState.day, navState.trackName, navState.raceNumber, raceSummaries]);

  const [currentLeft, setCurrentLeft] = useState(arrowButtonWidth + 1);

  const scrollTo = 280 + 12;
  const [showRight, setShowRight] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const onScroll = position => {
    setHasScrolled(true);

    if (Number.isNaN(position)) {
      return;
    }
    clearTimeout(scrollIndex);
    scrollIndex = setTimeout(() => {
      setCurrentLeft(position);
    }, 50);
  };

  const handleMouseUp = element => element.className === 'race-picker' ? onScroll(racePickerRef.current.scrollLeft) : null;
  const renderLeftArrow = () => {
    const firstRaceSelected = firstSummary && firstSummary.raceId === selectedId;
    let showArrow;

    if (firstRaceSelected && !hasScrolled) {
      showArrow = false;
    } else {
      showArrow = currentLeft > arrowButtonWidth;
    }
    return React.createElement("div", {
      className: "racing-swipe-arrow racing-swipe-arrow-left ".concat(showArrow ? '' : 'hide-arrow'),
      onClick: () => {
        const position = document.getElementsByClassName('race-picker')[0].scrollLeft - scrollTo;
        onScroll(position);
      }
    }, showArrow && React.createElement(Icon, {
      color: "fc-black",
      icon: "badge-arrow-left",
      size: "600"
    }));
  };
  const renderRightArrow = () => {
    const lastRaceSelected = lastSummary && lastSummary.raceId === selectedId;
    let showArrow;

    if (lastRaceSelected && !hasScrolled) {
      showArrow = false;
    } else {
      showArrow = showRight;
    }
    return React.createElement("div", {
      className: "racing-swipe-arrow racing-swipe-arrow-right ".concat(showArrow ? '' : 'hide-arrow'),
      onClick: () => {
        const position = document.getElementsByClassName('race-picker')[0].scrollLeft + scrollTo;
        onScroll(position);
      },
      ref: rightArrowRef
    }, showArrow && React.createElement(Icon, {
      color: "fc-black",
      icon: "badge-arrow-right",
      size: "600"
    }));
  };
  useEffect(() => {
    if (selectedId && raceSummaries) {
      const index = raceSummaries.findIndex(element => element.raceId === selectedId);
      setCurrentLeft(index * scrollTo);
    }
  }, [raceSummaries, selectedId]);
  useEffect(() => {
    racePickerRef.current.scrollTo({
      behavior: 'smooth',
      left: currentLeft
    });
    if (!svs.core.detect.formfactor.mobile()) {
      setTimeout(() => {
        const rightSideOfDiv = 280 - arrowButtonWidth;
        if (rightArrowRef.current !== null) {
          setShowRight(rightArrowRef.current.offsetLeft < lastItemRef.current.offsetLeft + rightSideOfDiv);
        }
      }, 300);
    }
  }, [currentLeft]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "picker-header"
  }, "V\xE4lj lopp"), React.createElement("div", {
    className: "race-picker",
    onMouseUp: e => handleMouseUp(e.target),
    ref: racePickerRef
  }, !svs.core.detect.formfactor.mobile() && renderLeftArrow(), raceSummaries.map(raceSummary => {
    const jackpot = getFirstJackpot(raceSummary.raceId);
    let jackpotGameType;
    if (jackpot) {
      jackpotGameType = subProductIdToGameType[jackpot.jackpots[0].userProduct];
    }
    return React.createElement(Link, {
      key: "".concat(raceSummary.meeting.track.urlName, "_").concat(raceSummary.meeting.meetingNumber, "_").concat(raceSummary.raceNumber, "_").concat(raceSummary.raceId),
      to: buildLocationFromRace(raceSummary, jackpotGameType)
    }, React.createElement(RacePickerItem, {
      isLast: raceSummary.raceId === lastSummary.raceId,
      isSelected: raceSummary.raceId === selectedId,
      jackpot: jackpot,
      lastItemRef: lastItemRef,
      meeting: raceSummary.meeting,
      raceSummary: raceSummary
    }));
  }), !svs.core.detect.formfactor.mobile() && renderRightArrow()));
};
svs.racing_game.components.play.RacePicker = RacePicker;

 })(window);